import React from "react";
import {Helmet} from "react-helmet";
import { withRouter } from "react-router-dom";

import storeId from "../../config/storeId";

const MetaTitle = (props) => {
    const store = storeId();
    return (
        <div className="application">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{store} store</title>
                
            </Helmet>
        </div>
    );
}

export default withRouter(MetaTitle);